<template>
  <v-container>
    <!-- <v-row>
      <v-col>
        <span>Отступ</span>
        <v-text-field
          type="number"
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.offset"
          :error-messages="errorMessages.offset"
          @input="mixChangeListItemHandler($event, 'offset')"
        />
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <span>Единицы отступа</span>
        <v-select
          outlined
          :items="$options.size"
          item-text="title"
          item-value="value"
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.size"
          @change="mixChangeListItemHandler($event, 'size')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

const size = [
  {
    value: 'S',
    title: 'S - 24px'
  },
  {
    value: 'M',
    title: 'M - 48px'
  },
  {
    value: 'L',
    title: 'L - 104px'
  }
]
export default {
  name: 'SpacerWidget',
  mixins: [dynamicListItemMix],
  size: size
}
</script>
